import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const CataloguePage = lazyRouteComponent(() => import("@modules/catalogue/pages/CataloguePage"), "CataloguePage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/catalogue", component: CataloguePage })];
}
